export default __webpack_public_path__ + "static/media/1.aacd561a.jpg";